import { service } from '../axios';
//生成模拟考试/练习
export function mockExamGenerate(data) {
    return service({
        url: '/mock/generatePaper',
        method: 'post',
        data
    });
}
//获取练习详情
export function mockExamDetail(recordId) {
    return service({
        url: `/mock/detail/${recordId}`,
        method: 'get'
    });
}
/*保存答案*/
export function mockSaveAnswer(data) {
    return service({
        url: '/mock/saveAnswer',
        method: 'post',
        data
    });
}
//提交练习/模拟考试
export function mockSubmit(recordId) {
    return service({
        url: `/mock/submit/${recordId}`,
        method: 'post'
    });
}
//我的练习记录
export function mockMyRecord(params) {
    return service({
        url: '/mock/myRecord',
        method: 'get',
        params
    });
}
export function myMockPage(params) {
    return service({
        url: '/mock/myRecord',
        method: 'get',
        params
    });
}
export function getMockRecordPage(params) {
    return service({
        url: '/mock/myMockPage',
        method: 'get',
        params
    });
}
export function getWrongQuestionPage(params) {
    return service({
        url: '/mock/myWrongQuestionPage',
        method: 'get',
        params
    });
}
export function deleteWrongQuestion(id) {
    return service({
        url: `/mock/deleteWrongQuestion`,
        method: 'post',
        params: {
            id
        }
    });
}
